"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _get = _interopRequireDefault(require("lodash/get"));
var _find = _interopRequireDefault(require("lodash/find"));
var _map = _interopRequireDefault(require("lodash/map"));
var _highlightWordsCore = require("highlight-words-core");
var _displayError = _interopRequireDefault(require("../../utilities/displayError"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var customStyles = {
  control: function control(provided, _ref) {
    var isFocused = _ref.isFocused;
    var focusColors = isFocused ? {
      boxShadow: 0
    } : {};
    return _objectSpread(_objectSpread(_objectSpread({}, provided), focusColors), {}, {
      height: 42,
      borderColor: '#DDE0E6',
      cursor: 'text'
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: '#CED2DA'
    });
  },
  option: function option(provided, _ref2) {
    var isSelected = _ref2.isSelected,
      isFocused = _ref2.isFocused;
    return _objectSpread(_objectSpread({}, provided), {}, {
      backgroundColor: isSelected ? '#F8F9FA' : isFocused ? '#F8F9FA' : null,
      color: '#343840',
      padding: 8
    });
  },
  dropdownIndicator: function dropdownIndicator() {
    return {
      display: 'none'
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return {
      display: 'none'
    };
  },
  menu: function menu(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      marginTop: 0,
      boxShadow: 'none',
      border: '1px solid #DDE0E6'
    });
  }
};
var customTheme = function customTheme(theme) {
  return _objectSpread(_objectSpread({}, theme), {}, {
    borderRadius: 2,
    colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
      primary: '#DDE0E6',
      primary75: '#E9EBEF',
      primary50: '#E9EBEF',
      primary25: '#E9EBEF'
    })
  });
};
var formatOptionLabel = function formatOptionLabel(_ref3, _ref4) {
  var label = _ref3.label;
  var inputValue = _ref4.inputValue;
  var textToHighlight = label;
  var chunks = (0, _highlightWordsCore.findAll)({
    caseSensitive: false,
    textToHighlight: textToHighlight,
    autoEscape: true,
    searchWords: [inputValue]
  });
  return (0, _map.default)(chunks, function (chunk) {
    var end = chunk.end,
      highlight = chunk.highlight,
      start = chunk.start;
    var text = textToHighlight.substr(start, end - start);
    if (highlight) {
      return /*#__PURE__*/_react.default.createElement("b", {
        id: "".concat(text),
        className: "text-gray-darker"
      }, text);
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      id: "".concat(text),
      className: "space-type-value testing"
    }, text);
  });
};
var SearchField = /*#__PURE__*/function (_Component) {
  _inherits(SearchField, _Component);
  function SearchField(props) {
    var _this;
    _classCallCheck(this, SearchField);
    _this = _callSuper(this, SearchField, [props]);

    // Not using state for this value because the setting of this value needs to be sync
    _this.value = _this.props.input.value;
    _this.state = {
      menuIsOpen: false
    };
    _this.handleOnChange = _this.handleOnChange.bind(_assertThisInitialized(_this));
    _this.handleOnInputChange = _this.handleOnInputChange.bind(_assertThisInitialized(_this));
    _this.handleOnFocus = _this.handleOnFocus.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(SearchField, [{
    key: "handleOnChange",
    value: function handleOnChange(changeValue, _ref5) {
      var action = _ref5.action;
      var val = (0, _get.default)(changeValue, 'value');
      if ('select-option' === action) {
        this.value = val;
      }
      if (val || 0 === val) {
        this.props.input.onChange(val);
      }
    }
  }, {
    key: "handleOnInputChange",
    value: function handleOnInputChange(changeValue, _ref6) {
      var action = _ref6.action;
      if ('menu-close' === action) {
        this.setState({
          menuIsOpen: false
        });
      } else if ('input-blur' === action && !(0, _find.default)(this.props.options, {
        value: this.value
      })) {
        this.props.input.onChange(null);
        this.props.input.onBlur(null);
      } else if ('input-change' === action) {
        this.value = changeValue;
        this.props.input.onChange(changeValue);
        this.setState({
          menuIsOpen: !!changeValue
        });
      }
    }
  }, {
    key: "handleOnFocus",
    value: function handleOnFocus() {
      if (!this.props.input.value) {
        this.props.input.onChange(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className,
        _this$props$inputClas = _this$props.inputClassName,
        inputClassName = _this$props$inputClas === void 0 ? '' : _this$props$inputClas,
        _this$props$options = _this$props.options,
        options = _this$props$options === void 0 ? [] : _this$props$options,
        _this$props$input = _this$props.input,
        input = _this$props$input === void 0 ? {} : _this$props$input,
        _this$props$meta = _this$props.meta,
        meta = _this$props$meta === void 0 ? {} : _this$props$meta,
        _this$props$styles = _this$props.styles,
        styles = _this$props$styles === void 0 ? null : _this$props$styles,
        _this$props$placehold = _this$props.placeholder,
        placeholder = _this$props$placehold === void 0 ? null : _this$props$placehold,
        _this$props$errorMess = _this$props.errorMessage,
        errorMessage = _this$props$errorMess === void 0 ? null : _this$props$errorMess,
        _this$props$maxMenuHe = _this$props.maxMenuHeight,
        maxMenuHeight = _this$props$maxMenuHe === void 0 ? 300 : _this$props$maxMenuHe,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? '' : _this$props$id,
        _this$props$attribute = _this$props.attributes,
        attributes = _this$props$attribute === void 0 ? {} : _this$props$attribute,
        isDisabled = _this$props.isDisabled,
        classNamePrefix = _this$props.classNamePrefix,
        _this$props$menuPlace = _this$props.menuPlacement,
        menuPlacement = _this$props$menuPlace === void 0 ? 'bottom' : _this$props$menuPlace,
        _this$props$isSearcha = _this$props.isSearchable,
        isSearchable = _this$props$isSearcha === void 0 ? true : _this$props$isSearcha,
        noOptionsMessage = _this$props.noOptionsMessage,
        components = _this$props.components;
      var error = meta.error,
        submitFailed = meta.submitFailed;
      var searchFieldClassNames = (0, _classnames.default)('SearchField', className);
      var name = input.name,
        value = input.value;
      var reduxFormValue = (0, _find.default)(options, {
        value: value
      }) || '';
      var noOptions = function noOptions() {
        return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "forms.space_type_form.no_options",
          defaultMessage: "No options"
        });
      };
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: searchFieldClassNames
      }, attributes), /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
        name: name,
        value: reduxFormValue,
        className: inputClassName,
        placeholder: placeholder,
        options: options,
        onChange: this.handleOnChange,
        onInputChange: this.handleOnInputChange,
        styles: styles || customStyles,
        theme: customTheme,
        maxMenuHeight: maxMenuHeight,
        inputId: id,
        isDisabled: isDisabled,
        classNamePrefix: classNamePrefix,
        menuPlacement: menuPlacement,
        onFocus: this.handleOnFocus,
        isClearable: true,
        openMenuOnClick: false,
        menuIsOpen: this.state.menuIsOpen,
        blurInputOnSelect: true,
        formatOptionLabel: formatOptionLabel,
        isSearchable: isSearchable,
        noOptionsMessage: noOptionsMessage || noOptions,
        components: components
      }), !!(error && submitFailed) && /*#__PURE__*/_react.default.createElement("p", {
        className: "error text-danger text-small"
      }, (0, _displayError.default)(errorMessage, error)));
    }
  }]);
  return SearchField;
}(_react.Component);
SearchField.propTypes = {
  className: _propTypes.default.string,
  inputClassName: _propTypes.default.string,
  options: _propTypes.default.array,
  input: _propTypes.default.object,
  meta: _propTypes.default.object,
  placeholder: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  styles: _propTypes.default.object,
  id: _propTypes.default.string,
  removeSelections: _propTypes.default.bool,
  maxMenuHeight: _propTypes.default.number,
  attributes: _propTypes.default.object,
  allOptions: _propTypes.default.array,
  isDisabled: _propTypes.default.bool,
  classNamePrefix: _propTypes.default.string,
  menuPlacement: _propTypes.default.string,
  isSearchable: _propTypes.default.bool,
  noOptionsMessage: _propTypes.default.string,
  components: _propTypes.default.object
};
var _default = exports.default = SearchField;